module.exports = __webpack_public_path__ + "static/rabi-87cdd2326354c0b57d3542c8709ca3db.png";